<app-mat-spinner-overlay [overlay]="true" *ngIf="this.loading > 0">
</app-mat-spinner-overlay>
<div *ngIf="usuario && usuario.sucesso" class="supercombo-modal panel panel-default form-filtrar form-default" [ngClass]="usuario.retorno.aparencia">
    <h1>Seleção de Motoristas</h1>
    <button type="button" mat-icon-button style="top: -10px; right: -10px; position: absolute;" matTooltip="Fechar" (click)="fechar()">
        <mat-icon aria-hidden="false" aria-label="Fechar" fontIcon="close">
        </mat-icon>
    </button>
    <form (ngSubmit)="onSubmit()" #filtroForm="ngForm" class="panel-body">
        <div class="input-group">
            <label class="center-block">
                Pesquisar por
            </label>
            <div class="input-group"></div>
            <mat-select [(ngModel)]="filtro.coluna" name="coluna" class="form-control dropdown-filtro"
                matTooltip="Pesquise o motorista por" style="min-width: 100px; max-width: 200px;">
                <mat-option *ngFor="let op of opcoesColunaPesquisa" [value]="op.value">
                    {{ op.label }}
                </mat-option>
            </mat-select>
            <mat-select [(ngModel)]="filtro.operador" name="operador" class="form-control dropdown-filtro"
                style="min-width: 100px; max-width: 200px; margin-left: 10px;">
                <mat-option [value]=1>Igual a</mat-option>
                <mat-option [value]=2>Maior que</mat-option>
                <mat-option [value]=3>Menor que</mat-option>
                <mat-option [value]=4>Contendo</mat-option>
                <mat-option [value]=5>Iniciando por</mat-option>
            </mat-select>
            <input type="text" #search required [(ngModel)]="filtro.parametro" name="parametro" id="parametro"
                class="form-control"
                style="margin-left: 10px; min-width: 200px;" matTooltip="Preecha para a pesquisa do motorista"
                #parametro="ngModel" />
            <div [hidden]="parametro.valid || parametro.pristine" style="margin-left: 10px; padding-top: 10px; color: #7d0c12">
                <span>Campo é obrigatório</span>
            </div>
            <button type="submit"
                mat-icon-button style="margin-left: 10px"
                matTooltip="Pesquise o motorista"
                [disabled]="!filtroForm.form.valid">
                    <mat-icon aria-hidden="false" aria-label="Pesquise motorista" fontIcon="search"></mat-icon>
            </button>
            <button type="button" mat-icon-button style="margin-left: 10px" matTooltip="Limpe o resultado da pesquisa de motorista"
                (click)="limpaFiltro()">
                <mat-icon aria-hidden="false" aria-label="Limpe o resultado da pesquisa de motorista" fontIcon="delete">
                </mat-icon>
            </button>
            <button type="button" mat-icon-button style="margin-left: 10px" matTooltip="Fechar" (click)="fechar()">
                <mat-icon aria-hidden="false" aria-label="Fechar" fontIcon="close">
                </mat-icon>
            </button>
        </div>
    </form>
    <div>
        <mat-form-field class="pesquisa-filtro">
            <input matInput #txtVal (keyup)="applyFilter(txtVal.value)" placeholder="Digite para pesquisar motorista ...">
        </mat-form-field>
    </div>
    <div class="lista-container">
        <mat-table [dataSource]="dataSource" matSort>

            <ng-container matColumnDef="nome">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Nome </mat-header-cell>
                <mat-cell *matCellDef="let row"> {{ row.nome }} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="apelido">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Apelido </mat-header-cell>
                <mat-cell *matCellDef="let row"> {{ row.apelido }} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="cpf">
                <mat-header-cell *matHeaderCellDef mat-sort-header> CPF </mat-header-cell>
                <mat-cell *matCellDef="let row"> {{ row.cpf | cpfFormat }} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="matricula">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Matrícula </mat-header-cell>
                <mat-cell *matCellDef="let row"> {{ row.matricula }} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="celular">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Celular </mat-header-cell>
                <mat-cell *matCellDef="let row"> {{ formatCelular(row) }} </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns;" class="pesquisa-motorista-am-row" (click)="getRecord(row)">
            </mat-row>

        </mat-table>

        <mat-paginator #paginator class="filter-paginator" [pageSizeOptions]="[5, 10, 20, 50, 100, 500, 1000, 9999]"
            [pageSize]="5" aria-label="Seleciona a página">
        </mat-paginator>
    </div>
</div>
